import React from "react";
import { showPlaceholderNames, testimonials } from "../data/siteData";

function TestimonialsSection() {
  return (
    <section id="testimonials" className="section">
      <p className="eyebrow center">Trusted by doctors</p>
      <h2 className="center">What clinics say about byond care.</h2>
      <article className="card testimonial-card">
        {testimonials.slice(0, 1).map((item) => (
          <div key={item.id} className="quote">
            <div className="quote__mark">&quot;</div>
            <p className="quote__text">{item.text}</p>
            {showPlaceholderNames && (
              <div className="quote__author">
                <div className="quote__avatar">DR</div>
                <h4>{item.author}</h4>
              </div>
            )}
          </div>
        ))}
      </article>
    </section>
  );
}

export default TestimonialsSection;
